import { ArrowLeftThin, ArrowRightThin } from '@ori-ui/icons';
import { Link, styled } from '@ori-ui/mui';
import { shouldNotForwardProp } from '@ori/presentation-utils';
export const BreadcrumbsWrapper = styled('div')(({
  theme
}) => ({
  alignItems: 'center',
  color: 'inherit',
  display: 'flex',
  flexDirection: 'row',
  fontFamily: 'inherit',
  fontSize: theme.typography.pxToRem(12)
}));
export const StyledLink = styled(Link, {
  shouldForwardProp: shouldNotForwardProp(['isLast', 'isMobile'])
})(({
  isLast,
  isMobile,
  theme
}) => ({
  color: 'inherit',
  fontWeight: isLast ? 'bold' : 'normal',
  marginLeft: isMobile ? theme.spacing(1) : undefined,
  textDecoration: 'none',
  '&:hover, &:focus': {
    color: 'inherit',
    fontWeight: isLast ? 'bold' : 'normal',
    textDecoration: 'underline'
  }
}));
export const StyledArrowLeftThin = styled(ArrowLeftThin)(({
  theme
}) => ({
  fontSize: theme.typography.pxToRem(18),
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(10)
  }
}));
export const StyledArrowRightThin = styled(ArrowRightThin)(({
  theme
}) => ({
  fontSize: theme.typography.pxToRem(18),
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(10)
  }
}));
export const StyledWrapper = styled('div')({
  alignItems: 'center',
  display: 'flex'
});
export const ItemWrapper = styled('span')(({
  theme
}) => ({
  fontSize: theme.typography.pxToRem(12),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1.5),
  position: 'relative'
}));
//# sourceMappingURL=styles.js.map